import appRoles from "../auth/roles-info";
import { useUser } from "../contexts/userContext";

export const useAuth = () => {
	const { userData } = useUser();

	function getRoleDisplayName(isAdmin, isBulkEmailAdmin) {
		if (isAdmin) return appRoles.admin.displayName;
		if (isBulkEmailAdmin) return appRoles.bulkEmailAdmin.displayName;
		return appRoles.anonymous.displayName;
	}

	function getRoleName(isAdmin, isBulkEmailAdmin) {
		if (isAdmin) return appRoles.admin.name;
		if (isBulkEmailAdmin) return appRoles.bulkEmailAdmin.name;
		return appRoles.anonymous.name;
	}

	function canAccessAdminFeatures() {
		return userData?.isAdmin && userData?.isActive;
	}

	function canAccessBulkEmailFeatures() {
		return (
			(userData?.isBulkEmailAdmin || userData?.isAdmin) &&
			userData?.isActive
		);
	}

	function canActivate(permissionName) {
		if (!permissionName) {
			console.error("Permission name is required.");
			return false;
		}

		switch (permissionName) {
			case appRoles.admin.name:
				return canAccessAdminFeatures();
			case appRoles.bulkEmailAdmin.name:
				return canAccessBulkEmailFeatures();
			case appRoles.anonymous.name: // Any authenticated user has access.
				return true;
			default:
				console.error(
					`useAuth.js - ${permissionName} role is not supported.`
				);
				return false;
		}
	}

	return {
		isAdmin: userData?.isAdmin ?? false,
		isBulkEmailAdmin: userData?.isBulkEmailAdmin ?? false,
		canAccessUi: userData?.canAccessUi ?? false,
		isActive: userData?.isActive ?? false,
		email: userData?.email,
		roleDisplayName: getRoleDisplayName(
			userData?.isAdmin,
			userData?.isBulkEmailAdmin
		),
		roleName: getRoleName(userData?.isAdmin, userData?.isBulkEmailAdmin),
		accessToken: userData?.accessToken,

		// Helper methods for checking permissions
		canAccessAdminFeatures,
		canAccessBulkEmailFeatures,
		canActivate,
	};
};
